<div class="card-wrap" *ngIf="!isEmbedded else singletournamentview">
    <a [ngClass]="{'finished':isRegularTournament()?.tournamentType === 2 || isFinished}">
        <div class="card-img" [ngClass]="{'finished': isFinished}">
            <div class="badge-container batch-bg-0" *ngIf="isRegularTournament()?.tournamentType === 0 && !isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/desktop/tournament/icon-category-tournament-live.png" alt="badge-icon-0">
                <span i18n>Live</span>
            </div>
            <div class="badge-container batch-bg-0" *ngIf="tournament.isNetworkTournament && !isFinished">
                <img class="live-icon" src="assets/desktop/tournament/icon-category-tournament-network.png" alt="icon-tournament-network">
                <span i18n>Network</span>
            </div>
            <div class="badge-container batch-bg-0" *ngIf="isRegularTournament()?.tournamentType === 1">
                <img class="live-icon" src="assets/desktop/tournament/icon-category-tournament-scheduled.png" alt="badge-icon-1">
                <span i18n>Starts soon!</span>
            </div>
            <!-- <div class="badge-container batch-bg-2" *ngIf="isRegularTournament()?.tournamentType === 2">
                <img class="live-icon" src="assets/mobile/badge-icon-3.svg">
                <span i18n>Completed</span>
            </div> -->
            <div class="badge-container batch-bg-3" *ngIf="isRegularTournament()?.tournamentType === 0 && isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/mobile/icon-locked.svg" alt="icon-private">
                <span i18n>Private</span>
            </div>
            <img [src]="tournament.thumbnailDesktop?.url">
        </div>
        <div class="card-info">
            <div class="bottom">
                <h5>{{tournament?.name | removehtml}}</h5>
                <div fxLayoutAlign="space-between left" fxLayout="column" fxLayoutGap="4px">
                    <div fxLayoutAlign="left center" fxLayout="row" fxLayoutGap="8px">
                        <img *ngIf="!tournament.isNetworkTournament" class="tournament-type-{{isRegularTournament()?.tournamentType}}" src="assets/desktop/tournament/icon-tournament-type-{{isRegularTournament()?.tournamentType}}.svg" alt="icon-tournament-type-{{isRegularTournament()?.tournamentType}}">
                        <img *ngIf="tournament.isNetworkTournament && isFinished" class="tournament-type-2" src="assets/desktop/tournament/icon-tournament-type-2.svg" alt="icon-tournament-type-2">
                        <img *ngIf="tournament.isNetworkTournament && !isFinished" class="tournament-type-{{(tournament.isNetworkTournament && tournamentStartDateLocal<now)===true?0:1}}" class="tournament-type-network" src="assets/desktop/tournament/icon-tournament-type-{{(tournament.isNetworkTournament && tournamentStartDateLocal<now)===true?0:1}}.svg" alt="icon-tournament-type-0">
                        <!-- <mat-icon class="status-icon">{{isRegularTournament()?.tournamentType === 2?'sports_score':'hourglass_top'}}</mat-icon> -->
                        <span>
                            <ng-container *ngIf="!isFinished else finished">
                                <div *ngIf="isRegularTournament()?.tournamentType === 0 || (tournament.isNetworkTournament && tournamentStartDateLocal<now)" class="time">
                                    <div #tournamentstartdate></div>
                                    <!-- <ng-container *ngIf="tournamentStartDateLocal>now">
                                        {{ tournamentStartDateLocal | date : 'short':'':locale
                                        }}<br />
                                        <span i18n>Starting soon</span>
                                    </ng-container> -->
                                </div>
                            </ng-container>
                            <div *ngIf="isRegularTournament()?.tournamentType === 1 || (tournament.isNetworkTournament && tournamentStartDateLocal>now)" class="time">{{ tournamentStartDateLocal | date : 'short':'':locale
                                }}
                            </div>
                            <div *ngIf="isRegularTournament()?.tournamentType === 2">
                                <div i18n>Finished</div>
                                <!-- <div class="time">{{ tournamentEndDateLocal | date : 'short':'':locale}}</div> -->
                            </div>
                        </span>
                    </div>
                    <div fxLayoutAlign="left center" fxLayout="row" fxLayoutGap="8px">
                        <img *ngIf="isRegularTournament()?.tournamentType === 2 || isFinished" class="tournament-type-{{isRegularTournament()?.tournamentType}}" src="assets/desktop/tournament/icon-games-collection-inactive.svg" alt="icon-games-collection-inactive">
                        <img *ngIf="isRegularTournament()?.tournamentType !== 2 && !isFinished" class="tournament-type-{{isRegularTournament()?.tournamentType}}" src="assets/desktop/tournament/games.svg" alt="games">
                        <div *ngIf="isRegularTournament()?.tournamentType === 1 || isRegularTournament()?.tournamentType === 0 || (tournament.isNetworkTournament && !isFinished); then gamepresentation else tournamenttitle"></div>
                    </div>
                </div>
            </div>
            <div class="cart-info-btn">
                <ng-container *loggedRender>
                    <button round-button (click)="buttonClick()" filled="filled" *ngIf="isRegularTournament()?.tournamentType === 0 || (tournament.isNetworkTournament && !isFinished && tournamentStartDateLocal<now)" mat-stroked-button color="orange" [routerLink]="[routeURL,'id',tournament.cmsId]" [queryParams]="{ref: fromURL}" i18n>Play</button>
                    <button round-button (click)="buttonClick()" *ngIf="(!tournament.isNetworkTournament && isRegularTournament()?.tournamentType !== 0 && isRegularTournament()?.tournamentType !==2) || (tournament.isNetworkTournament && !isFinished && tournamentStartDateLocal>now)" mat-stroked-button color="warn" [routerLink]="[routeURL,'id',tournament?.cmsId]" [queryParams]="{ref: fromURL}" i18n>Info</button>
                    <button round-button (click)="buttonClick()" *ngIf="isRegularTournament()?.tournamentType === 2 || isFinished" class="btn-disabled" mat-stroked-button color="warn" [routerLink]="[routeURL,'id',isRegularTournament()?.cmsId || tournament.cmsId]" [queryParams]="{ref: fromURL}" i18n>Info</button>
                </ng-container>
                <ng-container *loggedHide>
                    <button round-button (click)="buttonClick()" *ngIf="(isRegularTournament()?.tournamentType !==2 && !isFinished) || (tournament.isNetworkTournament && !isFinished)" mat-stroked-button color="warn" [routerLink]="[routeURL,'id',tournament.cmsId]" [queryParams]="{ref: fromURL}" i18n>Info</button>
                    <button round-button (click)="buttonClick()" *ngIf="isRegularTournament()?.tournamentType === 2 || isFinished" class="btn-disabled" mat-stroked-button color="warn" [routerLink]="[routeURL,'id',isRegularTournament()?.cmsId || tournament.cmsId]" [queryParams]="{ref: fromURL}" i18n>Info</button>
                    <button round-button (click)="buttonClick()" filled="filled" *ngIf="isRegularTournament()?.tournamentType === 0 || (tournament.isNetworkTournament && !isFinished && tournamentStartDateLocal<now)" mat-stroked-button color="orange" (click)="login()" i18n>Play</button>
                </ng-container>

            </div>
        </div>
    </a>
</div>

<ng-template #singletournamentview>
    <div class="tournament-single-card" [ngClass]="{'finished':isRegularTournament()?.tournamentType === 2 || isFinished}">
        <div class="card-img">
            <div class="badge-container batch-bg-0" *ngIf="isRegularTournament()?.tournamentType === 0 && !isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/mobile/live.png" alt="badge-icon-0">
                <span i18n>Live</span>
            </div>
            <div class="badge-container batch-bg-0" *ngIf="isRegularTournament()?.tournamentType === 1">
                <img class="live-icon" src="assets/mobile/start-soon.png" alt="badge-icon-1">
                <span i18n>Starts Soon!</span>
            </div>
            <!-- <div class="badge-container batch-bg-2" *ngIf="isRegularTournament()?.tournamentType === 2">
                <img class="live-icon" src="assets/mobile/badge-icon-3.svg">
                <span i18n>Completed</span>
            </div> -->
            <div class="badge-container batch-bg-3" *ngIf="isRegularTournament()?.tournamentType === 0 && isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/mobile/icon-locked.svg" alt="icon-private">
                <span i18n>Private</span>
            </div>
            <div class="badge-container batch-bg-0" *ngIf="tournament.isNetworkTournament && !isFinished">
                <img class="live-icon" src="assets/mobile/network.png" alt="icon-tournament-network">
                <span i18n>Network</span>
            </div>
            <img class="singletournamentview-img" [src]="tournament.largeDesktopBanner?.url">
        </div>
        <div class="banner-content">
            <div class="banner-content-heads">
                <div class="title">
                    {{tournament?.name | removehtml}}
                </div>
                <div class="duration">
                    <ng-container *ngIf="!isFinished || tournament.isNetworkTournament else finished">
                        <div *ngIf="(tournament.isNetworkTournament && !isFinished && tournamentStartDateLocal<now) || isRegularTournament()?.tournamentType === 0" class="time" style="display: flex; gap: 4px;">
                            <img class="icon" src="assets/desktop/icon-time-left.png" alt="icon-time-left"/><span i18n>Time left:</span>
                            <ng-container class="time-left" *ngIf="tournamentStartDateLocal<=now">
                                <div #tournamentstartdate class="time-money-bold"></div>
                            </ng-container>
                            <!-- <ng-container *ngIf="tournamentStartDateLocal>now">
                                {{ tournamentStartDateLocal | date : 'short':'':locale
                                }}<br />
                                <span i18n>Starting soon</span>
                            </ng-container> -->
                        </div>
                        <div class="time" *ngIf="minBet && isRegularTournament()?.tournamentType === 0" style="display: flex; gap: 4px;" i18n>Minimum bet:
                            <ng-container class="time-left" *ngIf="tournamentStartDateLocal<=now">
                                <div #tournamentstartdate class="time-money-bold">{{minBet}} {{minBetCurrency}}</div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="isRegularTournament()?.tournamentType === 2 || isFinished">
                    <div class="completed">
                        <img class="icon" src="assets/desktop/tournament/icon-completed-flag.svg" alt="icon-completed-flag"/>
                        <div i18n>Finished</div>
                    </div>
                </ng-container>
            </div>
            <div class="your-position" *ngIf="myPosition !== -1 && myPosition !== undefined">
                <h2 i18n>Your current position:</h2>
                <div class="your-position-section">
                    <span>{{myPosition}}.</span>
                    <div class="name-point-aria-cls">
                        <h2>{{rank[myPosition].nickname}}</h2>
                        <h2>{{rank[myPosition]?.points}} pts.</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #finished>
    <div i18n>Finished</div>
</ng-template>

<ng-template #gamepresentation>
    <div class="info-text">{{game}}</div>
</ng-template>

<ng-template #tournamenttitle>
    <div i18n>Tournament</div>
</ng-template>
